module.exports = __webpack_public_path__ + "img/flag_usa.b6ed3427.png";